export const GLOBAL_COPY = {
  learnMoreCta: 'Learn more.',
};
